import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import Header from "../sections/Header";
import Sidebar from "../sections/Sidebar";
import { encStorage } from "../hooks/encStorage";
import {
  GET_SEARCH_BANK,
  GET_BANKS_LIST,
  POST_NEW_BANK,
  CLIENT_OTP_URL,
  VERIFY_OTP_URL,
} from "../services/Apis";
import axios from "axios";
import { useNavigate } from "react-router-dom";

const Deposit = () => {
  const [SidebarState, setSidebarState] = useState(false);
  const [loading, setLoading] = useState(true);
  const [banks, setBanks] = useState([]);
  const [filteredBanks, setFilteredBanks] = useState([]);
  const [selectedBank, setSelectedBank] = useState(null);
  const [referenceNumber, setReferenceNumber] = useState("");
  const [attachment, setAttachment] = useState("");
  const [attachmentFile, setAttachmentFile] = useState(null);
  const [amtValidation, setAmtValidation] = useState("");
  const [refValidation, setRefValidation] = useState("");
  const [amount, setAmount] = useState("");
  const [ifsc, setIfsc] = useState("");
  const [ifscId, setIfscId] = useState("");
  const [accountNumber, setAccountNumber] = useState("");
  const [accountHolderName, setAccountHolderName] = useState("");
  const [upi, setUpi] = useState("");
  const [accountType, setAccountType] = useState(0);
  const [branchCode, setBranchCode] = useState("");
  const [branchAddress, setBranchAddress] = useState("");
  const [status, setStatus] = useState("");
  const [otp, setOtp] = useState("");
  const [otpVerified, setOtpVerified] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const token = encStorage.getItem("token");
        const response = await axios.get(GET_BANKS_LIST, {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        });
        setBanks(response.data.banks);
        setFilteredBanks(response.data.banks);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };

    fetchBanks();
  }, []);

  const updateSidebarState = (newState) => {
    setSidebarState(newState);
  };

  const handleBankSearch = async (e) => {
    const searchTerm = e.target.value;
    try {
      const token = encStorage.getItem("token");
      const response = await axios.get(GET_SEARCH_BANK, {
        params: { search: searchTerm },
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      setFilteredBanks(response.data.banks);
    } catch (error) {
      console.error("Error searching banks:", error);
    }
  };

  const handleBankSelect = (bankId) => {
    //console.log(bankId);
    const selected = bankId;
    if (selected) {
      setSelectedBank(bankId);
    } else {
      console.error("Selected bank not found");
    }
  };

  const handleOtpSubmit = async (promptVal) => {
    const token = encStorage.getItem("token");
    //console.log("promptVal", promptVal);
    try {
      const formData = new FormData();
      formData.append("otp", promptVal);
      const response = await axios.post(VERIFY_OTP_URL, formData, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
      console.log("response", response);
      if (response.data.message === "OTP verified successfully") {
        setOtpVerified(true);
        handleSubmit();
      } else {
        alert("OTP not verified");
      }
    } catch (error) {
      console.error("Error verifying OTP:", error);
      alert("OTP is not verified.");
    }
  };

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    const token = encStorage.getItem("token");

    if (!otpVerified) {
      try {
        await axios.post(
          CLIENT_OTP_URL,
          {},
          {
            headers: {
              Authorization: `Bearer ${token}`,
            },
          }
        );
        const promptVal = prompt("Enter OTP:");
        setOtp(promptVal);
        handleOtpSubmit(promptVal);
      } catch (error) {
        console.error("Error requesting OTP:", error);
        alert("Error requesting OTP");
      }
      return;
    }
  };

  const handleSubmit = async (e) => {
    const formData = new FormData();
    formData.append("ifsc", ifsc);
    formData.append("bank_id", selectedBank);
    formData.append("account_number", accountNumber);
    formData.append("account_holder_name", accountHolderName);
    formData.append("upi", upi);
    formData.append("account_type", accountType);
    formData.append("branch_code", branchCode);
    formData.append("branch_address", branchAddress);
    const token = encStorage.getItem("token");
    try {
      await axios.post(POST_NEW_BANK, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          Authorization: `Bearer ${token}`,
        },
      });
      navigate("/my-banks", {
        state: { message: "Bank added successfully!", status: 200 },
      });
    } catch (error) {
      navigate("/my-banks", {
        state: { message: "Error during Bank Addition!", status: 400 },
      });
    }
  };

  return (
    <>
      <Header updateState={updateSidebarState} />
      <div id="layoutSidenav">
        <Sidebar props={SidebarState} />
        <div id="layoutSidenav_content" className="layout-content">
          <main>
            <div className="container-fluid px-4">
              <div className="d-flex">
                <h3 className="mt-4 w-75">Add Bank</h3>
                <div className="mt-auto me-0 mb-2 w-25 d-flex justify-content-end">
                  <Link to="/my-banks" className="btn btn-primary" title="New">
                    <span className="d-md-inline">Back</span>
                  </Link>
                </div>
              </div>
              <div className="card mb-4">
                <div className="card-body">
                  <form
                    id="depositform"
                    method="POST"
                    encType="multipart/form-data"
                    onSubmit={handleFormSubmit}
                    className="row g-3"
                  >
                    <div className="form-group col-sm-6">
                      <label htmlFor="ifsc">IFSC</label>
                      <input
                        type="text"
                        className="form-control"
                        id="ifsc"
                        placeholder="Enter IFSC Code"
                        value={ifsc}
                        onChange={(e) => setIfsc(e.target.value)}
                        onKeyUp={handleBankSearch}
                        required
                      />
                      <input
                        type="hidden"
                        id="ifsc_id"
                        value={ifscId}
                        onChange={(e) => setIfscId(e.target.value)}
                      />
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="bank_id">Bank</label>
                      <select
                        className="form-control"
                        id="bank_id"
                        value={selectedBank}
                        onChange={(e) => handleBankSelect(e.target.value)}
                        required
                      >
                        <option value="">Select Bank</option>
                        {Array.isArray(banks) &&
                          banks.map((bank) => (
                            <option key={bank.id} value={bank.id}>
                              {bank.name}
                            </option>
                          ))}
                      </select>
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="account_number">Account Number</label>
                      <input
                        type="text"
                        className="form-control"
                        id="account_number"
                        placeholder="Enter Account Number"
                        value={accountNumber}
                        onChange={(e) => setAccountNumber(e.target.value)}
                        required
                      />
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="account_holder_name">
                        Account Holder Name
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="account_holder_name"
                        placeholder="Enter Account Holder Name"
                        value={accountHolderName}
                        onChange={(e) => setAccountHolderName(e.target.value)}
                        required
                      />
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="upi">UPI Id</label>
                      <input
                        type="text"
                        className="form-control"
                        id="upi"
                        placeholder="Optional"
                        value={upi}
                        onChange={(e) => setUpi(e.target.value)}
                      />
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="account_type">Account Type</label>
                      <select
                        className="form-control"
                        id="account_type"
                        value={accountType}
                        onChange={(e) => setAccountType(e.target.value)}
                        required
                      >
                        <option value="">Select Account Type</option>
                        <option value="0">Savings</option>
                        <option value="1">Current</option>
                      </select>
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="branch_code">Branch Code</label>
                      <input
                        type="text"
                        className="form-control"
                        id="branch_code"
                        placeholder="Enter Branch Code"
                        value={branchCode}
                        onChange={(e) => setBranchCode(e.target.value)}
                      />
                    </div>

                    <div className="form-group col-sm-6">
                      <label htmlFor="branch_address">Branch Address</label>
                      <textarea
                        className="form-control"
                        id="branch_address"
                        placeholder="Enter Branch Address"
                        value={branchAddress}
                        onChange={(e) => setBranchAddress(e.target.value)}
                      />
                    </div>
                    <div className="col-sm-12 mt-5">
                      <button
                        type="submit"
                        className="btn btn-primary btn-sm me-2"
                        id="submit"
                      >
                        Save
                      </button>
                      <Link
                        to="/my-banks"
                        className="btn btn-default bordered btn-sm"
                      >
                        Cancel
                      </Link>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </main>
        </div>
      </div>
    </>
  );
};

export default Deposit;
